<script setup>
    import { CubeIcon } from '@heroicons/vue/24/outline'
</script>

<template>
    <CubeIcon />
</template>
